import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import {
  getFilteredTaskTypesByModuleAndCategoryAndSubCategoryFromState,
  getRelatedCompaniesFromState,
  getSelectedCompaniesFromState,
  getUserFromState,
  selectRelatedLocationMap
} from 'src/app/store/selector/initialize.selector'
import { Observable } from 'rxjs'
import {
  LocationAPIModel,
  RelatedCompaniesAPIModel,
  SelectedCompanyAPIModel,
  TaskTypeAPIModel,
  UserAPIModel
} from 'src/app/models/api.model'
import { save_selected_companies } from 'src/app/store/action/initialize.action'

@Injectable({ providedIn: 'root' })
export class InitializeService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  getInitialSettingsData() {
    return this.webService.get(ServiceUrlConstants.API_INITIALISE)
  }

  getFilteredTaskTypes(module: string, category: string, subCategory: string): Observable<TaskTypeAPIModel[]> {
    return this.appState.select(
      getFilteredTaskTypesByModuleAndCategoryAndSubCategoryFromState(module, category, subCategory)
    )
  }

  getRelatedCompanies(): Observable<RelatedCompaniesAPIModel> {
    return this.appState.select(getRelatedCompaniesFromState)
  }

  dispatchSaveSelectedCompanies(selectedCompanies: SelectedCompanyAPIModel[]) {
    return this.appState.dispatch(save_selected_companies({ selectedCompanies }))
  }

  getSelectedCompanies(): Observable<SelectedCompanyAPIModel[]> {
    return this.appState.select(getSelectedCompaniesFromState)
  }

  getUserFromState(): Observable<UserAPIModel> {
    return this.appState.select(getUserFromState)
  }

  getRelatedLocationMap(): Observable<Map<string, LocationAPIModel[]>> {
    return this.appState.select(selectRelatedLocationMap)
  }
}
